export default "__VITE_ASSET__WhO6rcsi__"